<!-- 
Listing of levy collections
-->
<template>
  <div>
    <v-card :class="embedded ? 'v-card--flat' : 'home'">
      <our-simple-table-header
        :total-items="listing.paging.totalItems"
        @click:refresh="refresh"
      />
      <our-table-busy-indicator :show="!embedded && listing.loading"/>
      <v-data-table 
        ref="levyCollectionTable" 
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems" 
        :no-data-text="noDataText"
        must-sort 
        hide-actions
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click.stop="rowSelected(props.item.id, props.item)">
            <our-nav-col :row="`${props.item.year} ${props.item.type}`"/>
            <td>{{ props.item.year }}</td>
            <td>{{ lookups.levyCollectionTypeDescriptions[props.item.type] }}</td>
            <td>{{ lookups.levyCollectionStatusDescriptions[props.item.status] }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import tableMixins from "@/mixins/table.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as action from "@/store/levy-collections/action-types";
import * as mutation from "@/store/levy-collections/mutation-types";

export default {
  mixins: [tableMixins, lookupMixins, filterMixins],
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      action: action.LIST,
      pagingMutation: mutation.LIST_SET_PAGING,
      headers: [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Year", value: "Year", sortable: true, width: 100 },
        { text: "Type", value: "Type", sortable: true },
        { text: "Status", value: "Status", sortable: true }
      ]
    };
  },
  computed: {
    listing() {
      return this.$store.state.levyCollections.listing;
    },
    loaded() {
      return this.listing.loaded;
    }
  },
  watch: {
    loaded() {
      this.load();
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (!this.listing.loaded && !this.listing.loading) {
        this.refresh();
      }
    },
    refresh() {
      this.populate();
    }
  }
};
</script>
